import React from 'react';
import { graphql, StaticQuery } from 'gatsby';

const supportsIntersectionObserver = () => {
  if (typeof(window) !== "undefined") {
    return "IntersectionObserver" in window;
  }

  return false;
};

export default class CDNImage extends React.Component {
  constructor(props) {
    super(props);

    this.imgRef = React.createRef();
    this.undownloadedMessageRef = React.createRef();
  }

  componentDidMount() {
    if (supportsIntersectionObserver()) {
      let undownloadedMessage;
      if (this.undownloadedMessageRef.current) {
        undownloadedMessage = this.undownloadedMessageRef.current;
      }
      this.imgRef.current.src = this.imgRef.current.dataset.blursrc;

      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove('lazy');
            lazyImageObserver.unobserve(lazyImage);

            if (undownloadedMessage) {
              undownloadedMessage.classList.add('hidden');
            }
          }
        });
      });

      lazyImageObserver.observe(this.imgRef.current);
    }
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            site {
              siteMetadata {
                imageHost
              }
            }
          }
        `}
        render={data => {
          let params = '';
          let paramGroups = [];

          if (this.props.fit) {
            paramGroups.push(`fit=${this.props.fit}`);
          }
          if (this.props.width) {
            paramGroups.push(`w=${this.props.width}`);
          }
          if (this.props.height) {
            paramGroups.push(`h=${this.props.height}`);
          } else if (!this.props.naturalSize) {
            paramGroups.push(`h=1200`);
          }
          if (this.props.minWidth) {
            paramGroups.push(`min-w=${this.props.minWidth}`);
          }
          if (this.props.minHeight) {
            paramGroups.push(`min-h=${this.props.minHeight}`);
          }

          paramGroups.push("auto=format,compress");

          if (paramGroups.length > 0) {
            params = paramGroups.join('&')
          }

          let src = `${data.site.siteMetadata.imageHost}${this.props.imagePath}`;
          if (!this.props.noProcessing) {
            src = `${src}?${params}`;
          }
          const blurSrc = `${data.site.siteMetadata.imageHost}${this.props.imagePath}?${params}&blur=1500&q=20`;

          return (
            <>
              <img src={ src }
                ref={ this.imgRef }
                data-blursrc={ blurSrc }
                data-src={ src }
                alt={this.props.alt}
                className={`${this.props.className} lazy ${this.props.flexibleHeight ? 'flexible-height' : ''}`}
              />
              {this.props.showUndownloadedMessage && (
                <span
                  className="undownloaded-image"
                  ref={ this.undownloadedMessageRef }
                >
                  Scroll through the whole page to download all images before printing.
                </span>
              )}
            </>
          );
        }}
      />
    );
  }
}
